import React, { useContext } from 'react';
import Config from '../../../appConfig';
import { ConfigContext } from '../../../Context/ConfigContext';

const GetPaymentMethods = ({ part }) => {

    const { currency } = useContext(ConfigContext)

    return (
        <div className="payment-wrapper">
            <div className="row g-3">

                {/* Payment Methods */}
                <div className="col-md-7">
                    <div className="payment-card h-100">
                        <h4 className="payment-title">Methods of Payment:</h4>

                        <div className="payment-icons">
                            {
                                currency.toLowerCase() !== "usd" &&
                                <>
                                    <div className="icon-box">
                                        <img
                                            src="/assets/images/payment/visa.svg"
                                            alt="Visa"
                                        />
                                    </div>

                                    <div className="icon-box">
                                        <img
                                            src="/assets/images/payment/mc.svg"
                                            alt="Mastercard"
                                        />
                                    </div>


                                    <div className="icon-box">
                                        <img
                                            src="/assets/images/payment/ae.svg"
                                            alt="American Express"
                                        />
                                    </div>

                                    <div className="icon-box">
                                        <img
                                            src="/assets/images/payment/cod.png"
                                            alt="Cash on Delivery"
                                        />
                                    </div>

                                </>
                            }
                            <div className="icon-box">
                                <img
                                    src="/assets/images/payment/bank_transfer.svg"
                                    alt="Bank Transfer"
                                />
                            </div>
                        </div>

                        <div className="payment-info">
                            <p>
                                Would you like to learn more about
                                <strong> {part?.stock_brand_name} {part?.ART_PRODUCT_NAME} ?</strong>
                            </p>

                            <p>
                                Read the{" "}
                                <a href="/">
                                    {part?.ART_PRODUCT_NAME} {part?.ART_SEARCH_NUMBER} FAQ and customer reviews!
                                </a>
                            </p>

                            <p>
                                Need help? <a href="/">Contact us</a>
                            </p>
                        </div>
                    </div>
                </div>


                {/* Delivery Method */}
                <div className="col-md-5">
                    <div className="payment-card h-100">
                        <h4 className="payment-title">Delivery Method:</h4>

                        <div className="delivery-box">
                            <img
                                src={`${Config.country === "uae" ? '/assets/icons/GhayarTruck.png' : "/assets/icons/ksa_ghayar_truck.png"}`}
                                alt="EVRi"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .payment-wrapper {
                    margin-top: 30px;
                }

                .payment-card {
                    border: 1px solid #e5e5e5;
                    background: #fff;
                    padding: 18px;
                    border-radius: 4px;
                }

                .payment-title {
                    font-size: 18px;
                    font-weight: 600;
                    color: #222;
                    margin-bottom: 18px;
                }

                .payment-icons {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                    margin-bottom: 18px;
                }

                .icon-box {
                    width: 120px;
                    height: 48px;
                    border: 1px solid #f0f0f0;
                    background: #fafafa;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                    transition: 0.3s;
                }

                .icon-box:hover {
                    border-color: #d9d9d9;
                    background: #fff;
                }

                .icon-box img {
                    max-width: 70%;
                    max-height: 28px;
                    object-fit: contain;
                }

                .payment-info p {
                    font-size: 14px;
                    color: #555;
                    margin-bottom: 10px;
                    line-height: 1.6;
                }

                .payment-info a {
                    color: #1976d2;
                    text-decoration: none;
                }

                .payment-info a:hover {
                    text-decoration: underline;
                }

                .delivery-box {
                    width: 180px;
                    height: 55px;
                    border: 1px solid #f0f0f0;
                    background: #fafafa;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                }

                .delivery-box img {
                    max-width: 80%;
                    max-height: 50px;
                    object-fit: contain;
                }

                @media (max-width: 768px) {
                    .icon-box {
                        width: calc(50% - 6px);
                    }

                    .delivery-box {
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

export default GetPaymentMethods;